
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.61 14.286H2.39a.675.675 0 01-.477-1.15c1.021-1.02 1.842-1.99 1.842-5.463A4.25 4.25 0 018 3.43a4.25 4.25 0 014.245 4.244c0 3.488.83 4.45 1.842 5.463.423.423.12 1.15-.477 1.15M8 16.857A.858.858 0 017.143 16h1.714a.858.858 0 01-.857.857m7.193-5.038c-.607-.6-1.234-1.22-1.234-4.146A5.968 5.968 0 008.943 1.79a1.143 1.143 0 10-1.885 0A5.968 5.968 0 002.04 7.673c0 2.927-.627 3.547-1.234 4.146C-.91 13.516.347 16 2.39 16h3.324a2.286 2.286 0 004.572 0h3.324c2.043 0 3.3-2.485 1.583-4.18","fill":"#A2A2A2","fill-rule":"evenodd"}})])
          )
        }
      }
    